export default __webpack_public_path__ + "static/engravers-gothic-dd5e4ba30aa19ec91e9bb6abc89c4a60.woff2";